import { render, staticRenderFns } from "./OffsetPurchases.vue?vue&type=template&id=4a72abd4&"
import script from "./OffsetPurchases.vue?vue&type=script&lang=js&"
export * from "./OffsetPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports